import { type RefObject, useEffect } from 'react'

export const useHorizontalScrollSync = (
  elementRefs: Array<RefObject<HTMLElement | null>>,
  syncKey?: unknown
) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: refs are stable; syncKey rebinds when sticky scrollbar mounts/unmounts
  useEffect(() => {
    const nodes = elementRefs
      .map((ref) => ref.current)
      .filter((el): el is HTMLElement => el !== null)

    if (nodes.length < 2) return

    const [source, ...targets] = nodes
    if (!source) return

    for (const other of targets) {
      other.scrollLeft = source.scrollLeft
    }

    let syncing = false
    const listeners: Array<[HTMLElement, () => void]> = []

    for (const node of nodes) {
      const onScroll = () => {
        if (syncing) return
        syncing = true
        const left = node.scrollLeft
        for (const other of nodes) {
          if (other !== node) {
            other.scrollLeft = left
          }
        }
        syncing = false
      }
      node.addEventListener('scroll', onScroll, { passive: true })
      listeners.push([node, onScroll])
    }

    return () => {
      for (const [node, onScroll] of listeners) {
        node.removeEventListener('scroll', onScroll)
      }
    }
  }, [syncKey])
}
